import { useContext } from 'react';
import type { PropsWithChildren, RefObject } from 'react';
import { createStyles } from '@mantine/core';

import GamecenterHeader from '../GamecenterHeader/GamecenterHeader';
import { useContestContext } from '../../context/ContestContext/ContestContext';
import GamecenterPrevPathContext from '../../context/GamecenterPrevPathContext/GamecenterPrevPathContext';

import GamecenterNonScheduledNav from './GamecenterNonScheduledNav/GamecenterNonScheduledNav';

const useStyles = createStyles((theme, { isFlex }: { isFlex: boolean }) => ({
  headerContainer: {
    position: 'sticky',
    top: 0,
    zIndex: theme.other.zIndex.header,
  },
  container: {
    ...(isFlex
      ? {
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100svh',
        }
      : {}),
  },
}));

function GamecenterNonScheduledLayout({
  children,
  headerSlot,
  isFlex,
  headerRef,
}: PropsWithChildren<{
  headerSlot?: JSX.Element,
  isFlex?: boolean,
  headerRef?: RefObject<HTMLDivElement>,
}>) {
  const { classes } = useStyles({ isFlex });
  const { contest } = useContestContext();
  const { prevLocationBeforeGamecenter } = useContext(GamecenterPrevPathContext);

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer} ref={headerRef}>
        <GamecenterHeader closeHref={prevLocationBeforeGamecenter} contest={contest} />
        <GamecenterNonScheduledNav contest={contest} />
        {headerSlot}
      </div>
      {children}
    </div>
  );
}

export default GamecenterNonScheduledLayout;
